import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import Config, { REQUIRED_CTKM_DISCOUNT } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import FormikFocusError from "app/common/form/FormikFocusError";
import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
import GlobitsAutocompleteTextAndSelect from "app/common/form/GlobitsAutocompleteTextAndSelect";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { isPaid, LIST_DATE_UNIT, PathModule, POPUP_TYPE_SERVICE } from "app/common/LocalConst";
import {
  formatMoney,
  getPriceTypeService,
  isAdmin,
  transformDate,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
} from "app/common/LocalFunction";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingHealthCareService } from "app/services/HealthCareService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo, useEffect, useState } from "react";
import * as Yup from "yup";
import RowTotalChangeService from "../../AllServicesTab/Component/RowTotalChangeService";
import RegisterServiceStaffsRevenue from "./RegisterServiceStaffsRevenue";
import { getListCode } from "app/services/CustomerSourceService";
import VoucherDepositDeductionTable from "../../../../DeductionList/VoucherDepositDeductionTable";
import OrderDepositDeductionTable from "../../../../DeductionList/OrderDepositDeductionTable";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import ReceiptIcon from "@material-ui/icons/Receipt";
import VoucherDepositDeductionPopup from "../../VoucherOrderDepositDeduction/VoucherDepositDeductionPopup";
import OrderDepositDeductionPopup from "../../VoucherOrderDepositDeduction/OrderDepositDeductionPopup";
import DeductionList from "app/PatientManagement/DeductionList/DeductionList";
const RegisterServicePopup = ({
  open,
  handleClose,
  onSubmit,
  initRegisterService,
  listVatPercent,
  handleAfterSubmit,
  resetPopupStore,
  customerSourceWalkIn,
}) => {
  const validationSchema = Yup.object().shape({
    department: Yup.object().nullable().required("Chưa chọn cơ sở!"),
    orderDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày đăng ký chưa đúng định dạng!")
      .nullable()
      .required("Chưa nhập ngày đăng ký"),
    percentDiscount: Yup.number()
      .min(0, "Giảm giá phải lớn hơn 0!")
      .max(100, "Giảm giá không vượt quá  100!")
      .nullable(),
    discount: Yup.number()
      .nullable()
      .test(
        "less-than-or-equals-to-totalAmount",
        "Tiền giảm giá không được lớn hơn tổng tiền",
        function (discount) {
          const { totalAmount } = this.parent;
          if (discount > totalAmount) return false;
          return true;
        }
      ),
    quantity: Yup.number().nullable().required("Chưa nhập số lượng!"),
    service: Yup.object().nullable().required("Chưa nhập dịch vụ!"),
    price: Yup.number()
      .min(0, "Giá phải lớn hơn 0!")
      .nullable()
      .required("Chưa nhập giá!"),

    totalAmount: Yup.number()
      .typeError("Thành tiền phải là số")

      .test(
        "validate-amount",
        "Không được bán dưới mức giá tối thiểu",
        function (value) {
          const { service, quantity } = this.parent;
          if (!service?.minSellingPrice || !value) {
            return true;
          } else {
            let minSellingPriceVal = value / quantity;
            if (minSellingPriceVal < service?.minSellingPrice) {
              return false;
            }
            return true;
          }
        }
      )
      .nullable(),
    staffRevenues: Yup.array()
      .min(1, "Cần thêm ít nhất 1 phân bổ!")

      .of(
        Yup.object()
          .shape({
            position: Yup.object()
              .nullable()
              .required("Bắt buộc nhập chức danh"),
            staff: Yup.object().nullable(),
            source: Yup.object()
              .nullable()
              .required("Bắt buộc nhập nguồn phân bổ")
              .test(
                "source-in-list",
                "Nguồn phân bổ không hợp lệ",
                function (value) {
                  const listCodeSource = this.options.context?.listCodeSource || [];

                  // Nếu chưa chọn hoặc thiếu code → invalid
                  if (!value || !value.code) return false;

                  // Không có danh sách thì cho pass
                  if (listCodeSource.length === 0) return true;

                  const first = listCodeSource[0];

                  // Mảng string: ["CTV", "KR", ...]
                  if (typeof first === "string") {
                    return listCodeSource.includes(value.code);
                  }

                  // Mảng object: [{code: "CTV"}]
                  if (typeof first === "object" && first !== null) {
                    return listCodeSource.some((item) => item.code === value.code);
                  }

                  return false;
                }
              ),
            actualAmount: Yup.mixed()
              .nullable()
              .test("greater-than-zero", "Giá trị phải lớn hơn 0!", (value) => {
                if (value === null || value === "") return true;
                return typeof value === "number" && value >= 0;
              }),
            percentRevenue: Yup.mixed()
              .nullable()
              .test(
                "max-100",
                "Phân bổ doanh thu phải nhỏ hơn hoặc bằng 100!",
                (value) => {
                  if (value === null || value === "") return true;
                  return typeof value === "number" && value <= 100;
                }
              ),
          })
          .test(
            "at-least-one-selected",
            "Phải chọn Nhân viên!",
            function (value) {
              if (!value) return false;
              const { staff } = value;
              return !!staff;
            }
          )
      )

      .test(
        "max-total-amount-telesale",
        "Tổng phân bổ telesale phải bằng 100%",
        validateMaxTotalAmountTelesale
      )
      .test(
        "max-total-amount-consultant",
        "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
        validateMaxTotalDiffTelesale
      )
      .test(
        "at-least-one-diffirent-sale",
        "Cần chọn phân bổ cho người tư vấn !",
        validateSelectDiffirentTelesale
      )
      .test(
        "at-least-one-sale",
        "Cần chọn phân bổ cho telesale!",
        validateSelectTelesale
      )
      .test(
        "equals-source-revenue-sale-diffirent",
        "Tổng phân bổ telesale phải bằng các chức danh khác trong cùng nguồn!",
        validateEqualsSourceDiffirentTelesale
      )
      .nullable(),
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const { handleGetListVatPercent, initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  const department = useDefaultDepartment();

  useEffect(() => {
    handleGetListVatPercent();
    return () => resetPopupStore();
  }, []);
  const source = initialPatient?.patientInfo?.currentPatientSource;

  const {
    listCodeSource
  } = useStore().patientManagementStore.allServicesTabStore;
  const handleGetListCodeSource = async (obj, setFieldValue) => {
    try {
      const { data } = await getListCode(obj);
      setFieldValue("listCodeSource", data || []);
    } catch (error) {
      //console.error(error);
    }
  }

  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`${initRegisterService?.id ? "Chỉnh sửa" : "Thêm"}  dịch vụ`}
      formik={{
        initialValues: {
          department,
          ...initRegisterService,
          sourceRevenue: source,
          listCodeSource: listCodeSource
        },
        onSubmit: async (value) => {
          await onSubmit(value);
          if (handleAfterSubmit) {
            handleAfterSubmit();
          }
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
      }}
      action={({ isSubmitting, values }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton
              type="submit"
              className="btn-primary"
              disabled={isSubmitting}
            >
              {!isMobile && <Save className="mr-2 " />}
              {`${initRegisterService?.id ? "Chỉnh sửa" : "Thêm"} dịch vụ`}
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              listVatPercent={listVatPercent}
              patient={initialPatient?.patientInfo}
              customerSourceWalkIn={customerSourceWalkIn}
              initRegisterService={initRegisterService}
            />
            <DialogError
              patient={initialPatient?.patientInfo}
              values={values}
              setFieldValue={setFieldValue}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({ listVatPercent, patient, customerSourceWalkIn, initRegisterService }) => {
    const { setFieldValue, values } = useFormikContext();
    const isDisabled =
      values?.isDisabled || isPaid({ value: values?.paymentStatus });
    let totalAmountRevenues = 0;
    if (values?.priceWithTax) {
      totalAmountRevenues =
        +values?.totalAmount - (+values?.discount || 0) || 0;
    } else {
      totalAmountRevenues =
        +values?.totalAmount -
        (+values?.discount || 0) +
        (+values?.taxTotal || 0) || 0;
    }

    const handleAllocationRevenue = (totalAmount, staffRevenues, oldCredit) => {
      const dataTotalAmount = totalAmount - oldCredit; // sử dụng tiền sau khi trừ đi tiền khấu trừ
      const { percentDifferenceOld, percentRevenueNew } =
        handleCalPercentRevenue(dataTotalAmount);

      staffRevenues = staffRevenues?.map((el) => {
        if (el?.originTreatmentId) {
          //xử lí tk cũ
          let percentRevenue = percentDifferenceOld * el?.percentRevenue;

          const actualAmount = Number(
            ((percentRevenue * dataTotalAmount) / 100).toFixed(4)
          );
          return {
            ...el,
            percentRevenue,
            actualAmount,
          };
        } else {
          let percentRevenue = percentRevenueNew > 0 ? percentRevenueNew : 0;
          const actualAmount = Number(
            ((percentRevenue * dataTotalAmount) / 100).toFixed(4)
          );
          return {
            ...el,
            percentRevenue,
            actualAmount,
          };
        }
      });
      return staffRevenues;
    };

    const handleCalPercentRevenue = (dataTotalAmount) => {
      if (!(dataTotalAmount > 1)) {
        return {
          percentDifferenceOld: 100,
          percentRevenueNew: 100,
        };
      }
      let percentDifferenceOld;
      let percentRevenueNew; //cth tính doanh thu dựa trên đã trả tiền hay chưa
      //nếu chưa trả thì lấy tiền phải trả / tổng để tính % ông cũ,
      // ông mới thì lấy tổng cần thu -  phải trả / tổng cần thu
      if (values?.oldProduct?.totalBillPatientPaid > 0) {
        const remaining =
          values?.oldProduct?.amountActuallyPaid -
          values?.oldProduct?.totalBillPatientPaid || 0;
        percentDifferenceOld = remaining / dataTotalAmount;

        percentRevenueNew =
          ((dataTotalAmount - remaining) / dataTotalAmount) * 100;
      } else {
        percentDifferenceOld =
          values?.oldProduct?.amountActuallyPaid / dataTotalAmount;
        percentRevenueNew =
          ((dataTotalAmount - values?.oldProduct?.amountActuallyPaid) /
            dataTotalAmount) *
          100;
      }
      return {
        percentDifferenceOld:
          percentDifferenceOld > 0 ? percentDifferenceOld : 0,
        percentRevenueNew: percentRevenueNew > 0 ? percentRevenueNew : 0,
      };
    };
    const [checkedState, setCheckedState] = useState(false);
    // Có dữ liệu cấn trừ hay không
    const hasData =
      (values?.voucherAllocations?.length || 0) > 0 ||
      (values?.invoiceItemAllocations?.length || 0) > 0;
    // Đang chỉnh sửa
    const isEdit = Boolean(initRegisterService?.id);
    // Checkbox hiển thị
    const checked = checkedState || hasData;
    // Disable CHỈ khi edit 
    const disabled = isEdit && hasData;
    return (
      <>
        <FormikFocusError />
        <Grid container spacing={1}>
          <Grid item xs={12} md={9}>
            <div className="sv-section-title">🔁 Thông tin đăng ký</div>
            <BodyForm
              isDisabled={isDisabled}
              patient={patient}
              customerSourceWalkIn={customerSourceWalkIn}
              listVatPercent={listVatPercent}
              handleAllocationRevenue={handleAllocationRevenue}
              checked={checked}
              disabled={disabled}
              setCheckedState={setCheckedState}
              isEdit={isEdit}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <RowTotalChangeService data={values} />
          </Grid>
          {/* Danh sách trừ tiền cọc và đơn hàng */}
          {checked && (
            <Grid item xs={12} md={12}>
              <DeductionList initRegisterService={initRegisterService} />
            </Grid>
          )}

          <Grid item xs={12} md={12}>
            <span class="symbol sv-section-title">⏳ Phân bổ</span>
            <div className="new-product-section">
              <Grid container spacing={1}>
                <RegisterServiceStaffsRevenue
                  totalAmount={totalAmountRevenues}
                  // isDisabled={isDisabled}
                  popupType={POPUP_TYPE_SERVICE}
                />
              </Grid>
            </div>
          </Grid>

        </Grid>
      </>
    );
  }
);

const DialogError = observer(({ patient, setFieldValue, values }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().patientManagementStore.registerServiceStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            if (!values?.id) {
              // khi đóng popup thì reset lại ngày đăng kí
              setFieldValue("orderDate", new Date());
            }
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${patient?.id}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Đăng ký thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});

const OldService = observer(({ handleAllocationRevenue, staffRevenuesOld }) => {
  const { values, setFieldValue } = useFormikContext();
  const totalPerformedTimes = getIn(
    values,
    "oldPatientServiceRegister.totalPerformedTimes"
  );
  const totalTreatmentTimes = getIn(
    values,
    "oldPatientServiceRegister.totalTreatmentTimes"
  );
  const service = getIn(values, "oldPatientServiceRegister.service");

  let percent = (+totalPerformedTimes * 100) / +totalTreatmentTimes || 0;
  return (
    <Grid container spacing={1} className="flex align-center justify-between">
      <Grid item xs={12} md={4}>
        <div className="pl-1 pr-1 old-service">
          <div>
            <span className="service-code">{service?.code}</span>{" "}
            <span className="service-name">{service?.tradeName}</span>
          </div>
          <div class="fancy-progress-wrapper mt-1">
            <div class="fancy-progress-text">
              {totalPerformedTimes} | {totalTreatmentTimes}
            </div>
            <div class="fancy-progress-bar">
              <div
                class="fancy-progress-fill"
                style={{ width: `${percent}%` }}
              ></div>
            </div>
          </div>
          <div className="flex mt-2">
            <span class="badge badge-old-service">Dịch vụ cũ</span>
            <div>
              Cần thu:{" "}
              <b style={{ color: "red" }}>
                {formatMoney(
                  values?.oldPatientServiceRegister?.amountActuallyPaid
                )}
              </b>
            </div>
            <span className="mx-2 text-gray-400">|</span>
            <div>
              Đã thu:{" "}
              <b style={{ color: "green" }}>
                {formatMoney(
                  values?.oldPatientServiceRegister?.totalBillPatientPaid || 0
                )}
              </b>
            </div>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldPatientServiceRegister.totalUsed"
          label="Tổng tiền đã dùng"
          disabled
        />
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldPatientServiceRegister.remainingAmount"
          label="Tổng tiền còn lại"
          disabled
        />
      </Grid>
      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldCredit"
          label="Tiền khấu trừ dịch vụ cũ"
          disabled
        />
      </Grid>
    </Grid>
  );
});

export const BodyForm = observer(
  ({ isDisabled, patient, customerSourceWalkIn, listVatPercent, checked, disabled, setCheckedState, isEdit }) => {
    let currentConsultant = patient?.currentConsultant;
    let currentTelesale = patient?.currentTelesale || patient?.currentTelesale2;
    let isAdminPermission = isAdmin();

    const handleChangeService = (value) => {
      setFieldValue("service", value);
      setFieldValue("name", value?.tradeName || value?.name);

      let feeItem =
        value?.serviceFeeList?.length > 0
          ? getPriceTypeService(
            getIn(values, "patientTypeService"),
            value?.serviceFeeList
          )
          : null;
      setFieldValue("taxPercent", feeItem?.serviceVAT?.vatPercent);
      setFieldValue("price", feeItem?.price);
      setFieldValue("priceWithTax", feeItem?.vatIncluded);
      setFieldValue("totalAmount", feeItem?.price * values?.quantity);

      let revenueAllocations = value?.revenueAllocations;
      if (revenueAllocations) {
        let staffRevenues = revenueAllocations?.map((el) => ({
          position: el?.position,
          percentRevenue: el?.commissionRate,
          source: patient?.currentPatientSource
            ? patient?.currentPatientSource
            : customerSourceWalkIn,
          staff:
            currentConsultant?.position?.code === el?.position?.code
              ? currentConsultant
              : currentTelesale?.position?.code === el?.position?.code
                ? currentTelesale
                : null,
        }));
        setFieldValue("staffRevenues", staffRevenues);
      } else {
        setFieldValue("staffRevenues", []);
      }

      setFieldValue("patientTypeService", {
        ...feeItem?.patientTypeService,
        price: feeItem?.price,
      });

      let taxPercent = feeItem?.serviceVAT?.vatPercent?.toString() || 0;

      setFieldValue("taxPercent", taxPercent);

      let taxTotal;
      if (feeItem?.vatIncluded) {
        taxTotal =
          ((feeItem?.price * values?.quantity - values?.discount) /
            (+taxPercent + 100)) *
          +taxPercent;
      } else {
        taxTotal =
          (feeItem?.price * values?.quantity - values?.discount) *
          ((+taxPercent || 0) / 100);
      }

      setFieldValue("taxTotal", taxTotal);
    };
    const { values, setFieldValue } = useFormikContext();
    return (
      <div className="new-product-section">
        {values?.oldPatientServiceRegister && (
          <Grid
            container
            spacing={1}
            style={{ backgroundColor: "aliceblue", marginBottom: "8px" }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <OldService />
            </Grid>
          </Grid>
        )}
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsPagingAutocomplete
              api={pagingDepartment}
              name={"department"}
              label="Cơ sở"
              disabled={isDisabled}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <GlobitsDateTimePicker
              name={"orderDate"}
              label="Ngày đăng ký"
              maxDateMessage="Ngày đăng ký phải trước ngày hiện tại"
              maxDate={new Date()}
              disabled={isDisabled}
              isDateTimePicker
              required
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <GlobitsPagingAutocomplete
              api={pagingHealthCareService}
              label={"Dịch vụ"}
              name={"service"}
              disabled={isDisabled}
              searchObject={{
                isUsing: true,
              }}
              getOptionLabel={(option) => option?.tradeName || option?.name || ""}
              renderOption={(item) => (
                <div
                  className="flex-wrap gap-1 w-100"
                  style={{ borderBottom: "1px solid #ccc" }}
                >
                  <b>{item?.tradeName || item?.name || ""}</b>({item?.code || ""})
                </div>
              )}
              searchFields={["tradeName", "name", "code"]}
              onChange={(_, value) => {
                handleChangeService(value);
              }}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsTextField
              name={"name"}
              label="Tên dịch vụ đăng ký"
            // disabled={isDisabled}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={1}>
            <GlobitsNumberInput
              label={"Số lượng"}
              name={"quantity"}
              disabled={isDisabled}
              onChange={(e) => {
                let quantity = e.target.value;
                setFieldValue("quantity", quantity);
                if (values?.price) {
                  setFieldValue("totalAmount", quantity * values?.price);
                }
              }}
              required
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <GlobitsAutocomplete
              label={"Loại giá"}
              disabled={isDisabled}
              options={values?.service?.serviceFeeList?.map((item) => ({
                ...item?.patientTypeService,
                price: item?.price,
                vatIncluded: item?.vatIncluded,
                serviceVAT: item?.serviceVAT,
              }))}
              onChange={(_, value) => {
                setFieldValue("patientTypeService", value);
                let vatPercent = +value?.serviceVAT?.vatPercent || 0;
                setFieldValue("price", value?.price);
                setFieldValue("priceWithTax", value?.vatIncluded);
                setFieldValue("taxPercent", vatPercent?.toString());

                let taxTotal;
                if (value?.vatIncluded) {
                  taxTotal =
                    ((value?.price * values?.quantity - values?.discount) /
                      (vatPercent + 100)) *
                    vatPercent;
                } else {
                  taxTotal =
                    (value?.price * values?.quantity - values?.discount) *
                    ((vatPercent || 0) / 100);
                }
                setFieldValue("taxTotal", taxTotal);
              }}
              name={"patientTypeService"}
              getOptionLabel={(option) => {
                return option?.name
                  ? `${option.name}${option?.price ? `: ${formatMoney(option.price)}` : ""
                  }`
                  : "";
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2} container alignItems="center">
            <GlobitsCheckBox
              label={"Giá kèm thuế"}
              name={"priceWithTax"}
              disabled
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <GlobitsVNDCurrencyInput
              label={"Giá"}
              name={"price"}
              disabled={isDisabled}
              onChange={(e) => {
                let price = +e.target.value;
                setFieldValue("price", price);
                let totalAmount = values?.quantity * price;
                setFieldValue("totalAmount", totalAmount);
                let discount = values?.discount;
                if (values?.percentDiscount) {
                  discount = (totalAmount * values?.percentDiscount) / 100;
                  setFieldValue("discount", discount);
                }

                let taxTotal;
                if (values?.priceWithTax) {
                  taxTotal =
                    ((totalAmount - discount) / (+values?.taxPercent + 100)) *
                    +values?.taxPercent;
                } else {
                  taxTotal =
                    (totalAmount - discount) *
                    ((+values?.taxPercent || 0) / 100);
                }
                setFieldValue("taxTotal", taxTotal);
              }}
              required
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <GlobitsVNDCurrencyInput
              label={"Thành tiền"}
              name={"totalAmount"}
              required
              disabled={isDisabled}
              onChange={(e) => {
                let totalAmount = e.target.value;
                setFieldValue("totalAmount", totalAmount);
                let discount = values?.discount;
                if (values?.percentDiscount) {
                  discount = (totalAmount * values?.percentDiscount) / 100;
                  setFieldValue("discount", discount);
                }
                let taxTotal;
                if (values?.priceWithTax) {
                  taxTotal =
                    ((totalAmount - discount) / (+values?.taxPercent + 100)) *
                    +values?.taxPercent;
                } else {
                  taxTotal =
                    (totalAmount - discount) *
                    ((+values?.taxPercent || 0) / 100);
                }
                setFieldValue("taxTotal", taxTotal);
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <GlobitsNumberInput
              label={"% giảm giá"}
              name={"percentDiscount"}
              disabled={
                isDisabled ||
                (REQUIRED_CTKM_DISCOUNT && !values?.promotionProgram)
              }
              onChange={(e) => {
                let percentDiscount = +e?.target.value;
                setFieldValue("percentDiscount", percentDiscount);
                setFieldValue(
                  "discount",
                  (values?.price * values?.quantity * percentDiscount) / 100
                );
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <GlobitsVNDCurrencyInput
              label={"Số tiền giảm"}
              name={"discount"}
              disabled={
                isDisabled ||
                (REQUIRED_CTKM_DISCOUNT && !values?.promotionProgram)
              }
              onChange={(e) => {
                let discount = +e?.target.value;
                setFieldValue("discount", discount);

                let taxTotal;
                if (values?.priceWithTax) {
                  taxTotal =
                    ((values?.price * values?.quantity - discount) /
                      (+values?.taxPercent + 100)) *
                    +values?.taxPercent;
                } else {
                  taxTotal =
                    (values?.price * values?.quantity - discount) *
                    ((+values?.taxPercent || 0) / 100);
                }

                setFieldValue("taxTotal", taxTotal);
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <GlobitsAutocompleteTextAndSelect
              options={listVatPercent || []}
              label={"% Vat"}
              name={"taxPercent"}
              value={values?.taxPercent}
              disabled={values?.priceWithTax || isDisabled}
              onInputChange={(newValue) => {
                setFieldValue("taxPercent", newValue?.toString());
                let taxTotal;
                if (values?.priceWithTax) {
                  taxTotal =
                    ((values?.price * values?.quantity - values?.discount) /
                      (+newValue + 100)) *
                    +newValue;
                } else {
                  taxTotal =
                    (values?.price * values?.quantity - values?.discount) *
                    (+newValue / 100);
                }

                setFieldValue("taxTotal", taxTotal);
              }}
              displayLabel={"vatPercent"}
              onChange={(value) => {
                setFieldValue("taxPercent", value?.vatPercent?.toString());
                let taxTotal;

                if (values?.priceWithTax) {
                  taxTotal =
                    ((values?.price * values?.quantity - values?.discount) /
                      (+value?.vatPercent + 100)) *
                    +value?.vatPercent;
                } else {
                  taxTotal =
                    (values?.price * values?.quantity - values?.discount) *
                    ((+value?.vatPercent || 0) / 100);
                }

                setFieldValue("taxTotal", taxTotal);
              }}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <GlobitsVNDCurrencyInput
              label={"Tiền Vat"}
              name={`taxTotal`}
              disabled
            />
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <GlobitsVNDCurrencyInput
              label="Số dư"
              name={`retainedAmount`}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsDateTimePicker
              name={"treatmentStartDate"}
              label="Ngày bắt đầu điều trị"
              disabled
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2} container alignItems="center">
            <GlobitsCheckBox label={"Bảo hành"} name={`hasWarranty`} disabled />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsNumberInput
              label={"Thời gian BH"}
              name={`warrantyDuration`}
              disabled={isDisabled || !isAdminPermission}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsSelectInput
              label={"Đơn vị BH"}
              options={LIST_DATE_UNIT}
              name={`warrantyUnit`}
              disabled={isDisabled || !isAdminPermission}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsNumberInput
              label={"Tổng số lần được BH"}
              name={`warrantyTotalTimes`}
              disabled={isDisabled || !isAdminPermission}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsDateTimePicker
              label={"Ngày hết hạn bảo hành"}
              name={`warrantyExpiryDate`}
              isDateTimePicker
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <GlobitsTextField label={"Ghi chú"} name={"note"} isTextArea />
          </Grid>
          <Grid item xs={6} sm={6} md={3} container alignItems="center">
            <GlobitsCheckBox
              label="Cấn trừ từ đơn hàng/tiền cọc"
              checked={checked}
              disabled={disabled}
              onChange={(e) => {
                const value = e.target.checked;
                setCheckedState(value);
                if (!value && !isEdit) {
                  setFieldValue("voucherAllocations", []);
                  setFieldValue("invoiceItemAllocations", []);
                }
              }}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
);
export default memo(observer(RegisterServicePopup));
